module.exports = __webpack_public_path__ + "static/faerie_dragon-4790758d1224f43a8b119b85314c06a9.png";